import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

// Dashboard - Keep this eager loaded as it's the main entry point
import DashboardEcommerce from "../pages/DashboardEcommerce";

// Login - Keep these eager loaded as they're critical for initial auth flow
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// Profile Settings (used for /settings-profile-settings)
const Settings = lazy(() => import("../pages/Pages/Profile/Settings/Settings"));

// User Profile - Lazy loaded
const UserProfile = lazy(() => import("../pages/Authentication/user-profile"));

// User Settings - Lazy loaded
const UserSettings = lazy(() => import("../pages/Users/UserSettings"));
const RoleManagement = lazy(() => import("../pages/Users/RoleManagement"));

// Import - Lazy loaded (single page: containers + invoices)
const ImportPage = lazy(() => import("../pages/Import"));

// Export - Lazy loaded (current stock, sell lot items)
const ExportPage = lazy(() => import("../pages/Export/index.js"));

// Miscellaneous - Lazy loaded (random payments, payment against invoices)
const MiscellaneousPage = lazy(() => import("../pages/Miscellaneous/index.js"));

// Reports - Lazy loaded
const InvoiceLedger = lazy(() => import("../pages/Reports/InvoiceLedger"));

// Settings - Lazy loaded
const Fruits = lazy(() => import("../pages/Settings/Fruits"));
const FruitsSubtypes = lazy(() => import("../pages/Settings/FruitsSubtypes"));
const Parties = lazy(() => import("../pages/Settings/Parties"));
const InvoiceType = lazy(() => import("../pages/Settings/InvoiceType"));
const InvoiceSubtype = lazy(() => import("../pages/Settings/InvoiceSubtype"));
const InvoiceParticulars = lazy(() => import("../pages/Settings/InvoiceParticulars"));
const Invoice = lazy(() => import("../pages/Settings/Invoice"));
const ShippingPort = lazy(() => import("../pages/Settings/ShippingPort"));
const Logs = lazy(() => import("../pages/Settings/Logs"));

const authProtectedRoutes = [
  { path: "/dashboard", component: <DashboardEcommerce /> },
  { path: "/index", component: <DashboardEcommerce /> },

  { path: "/settings-invoice", component: <Invoice /> },
  { path: "/settings-invoice-type", component: <InvoiceType /> },
  { path: "/settings-invoice-subtype", component: <InvoiceSubtype /> },
  { path: "/settings-invoice-particulars", component: <InvoiceParticulars /> },
  { path: "/settings-shipping-port", component: <ShippingPort /> },
  { path: "/settings-logs", component: <Logs /> },

  { path: "/user-settings", component: <UserSettings /> },

  { path: "/import", component: <ImportPage /> },
  { path: "/export", component: <ExportPage /> },
  { path: "/miscellaneous", component: <MiscellaneousPage /> },
  { path: "/invoice-ledger", component: <InvoiceLedger /> },
  { path: "/settings-role-management", component: <RoleManagement /> },
  { path: "/settings-profile-settings", component: <Settings /> },
  { path: "/settings-fruits-items", component: <Fruits /> },
  { path: "/settings-fruits-types", component: <FruitsSubtypes /> },
  { path: "/party-management", component: <Parties /> },
  { path: "/profile", component: <UserProfile /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
